import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';

import {
  CodeRequestModel,
  ErrorModel,
  ResponseModel,
  SessionTokenModel,
  UserImageModel
} from '../../../api/index';

import { ConfirmationPhoneRenterService } from '../../services/renter-form/confirmation-phone-renter.service';
import { RenterRegFormService } from '../../../../accounts/operator/services/renter-reg-form.service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { FormService } from '../../../services/form.service';
import { RenterForm } from '@core/components/abstract/renter-form';

@Component({
  selector: 'renter-registration',
  templateUrl: './renter-registration.component.html',
  styleUrls: ['./renter-registration.component.scss']
})
export class RenterRegistrationComponent extends RenterForm implements OnInit, OnDestroy {

  @Input() offPhoneNumber = false;
  @Input() verification = false;
  @Input() hiddenPassword = false;

  requestId: string = null;
  time = 0;

  timer: Subscription;

  requestConfirmationCode: Subscription;
  requestVerifyCode: Subscription;

  allowedPhotoTypes = [
    {
      type: UserImageModel.TypeEnum.PassportIdentityPage,
      label: this.i18n('Паспорт стр.32-33')
    },
    {
      type: UserImageModel.TypeEnum.PassportSignPage,
      label: this.i18n('Паспорт стр.31')
    },
    {
      type: UserImageModel.TypeEnum.PassportRegistrationPage,
      label: this.i18n('Регистрация')
    },
    {
      type: UserImageModel.TypeEnum.DriverLicenseFront,
      label: this.i18n('Фото ВУ')
    },
    {
      type: UserImageModel.TypeEnum.DriverLicenseBack,
      label: this.i18n('Фото ВУ (обр. сторона)')
    }
  ];

  hidePassword = true;
  hidePasswordConfirm = true;

  constructor(
    private formBuilder: FormBuilder,
    private formService: FormService,
    private confirmationPhoneRenterService: ConfirmationPhoneRenterService,
    private renterRegFormService: RenterRegFormService,
    private i18n: I18n
  ) {
    super();
  }

  get allowedRegistration() {
    return this.renterRegFormService.allowedRegistration;
  }

  set allowedRegistration(value) {
    this.renterRegFormService.allowedRegistration = value;
  }

  get form() {
    return this.renterRegFormService.renterForm;
  }

  get regForm() {
    return this.renterRegFormService.registrationForm;
  }

  get imagesForm() {
    return this.renterRegFormService.renterImagesForm;
  }

  reset() {
    this.time = 0;
    this.requestId = null;
    this.confirmationPhoneRenterService.reset();

    this.form.get('phone_number').enable();
  }

  private serverError(error: ErrorModel) {
    if (error) {
      this.formService.serverValidateForm(this.form, error);
      this.formService.serverValidateForm(this.regForm, error);
    }
  }

  private successConfirmationCode(res: ResponseModel<CodeRequestModel>) {
    if (res.success) {
      this.requestId = res.data.request_id;
      this.confirmationPhoneRenterService.timer = Date.now();
      this.regForm.get('code').enable();
    }
  }

  private successVerifyCode(res: ResponseModel<SessionTokenModel>) {
    if (res.success) {
      this.renterRegFormService.allowedRegistration = true;
      this.timer.unsubscribe();
      this.time = 0;

      this.regForm.get('code').disable();
      this.regForm.get('registration_token').setValue(res.data.token);
      this.form.get('phone_number').disable({ onlySelf: true, emitEvent: false });
    }
  }

  sendCode() {
    if(!this.form.controls['phone_number'].errors && !this.time) {
      this.requestConfirmationCode = this.confirmationPhoneRenterService.sendConfirmationCode(this.form.value['phone_number'])
        .subscribe(
          (res) => this.successConfirmationCode(res),
          (error) => this.serverError(error)
        );
    }
  }

  verifyCode() {
    if(!this.regForm.controls['code'].errors && !this.form.controls['phone_number'].errors) {
      this.requestVerifyCode = this.confirmationPhoneRenterService.verifyCode({
          code: this.regForm.value['code'],
          phone: this.form.controls['phone_number'].value,
          requestId: this.requestId
        })
        .subscribe(
          (res) =>this.successVerifyCode(res),
          (error) => this.serverError(error)
        );
    }
  }

  selectFile({ image, type }) {
    this.renterRegFormService.renterImagesForm.get(type).setValue(image);
  }

  ngOnInit() {
    this.timer = this.confirmationPhoneRenterService.time$.subscribe(time => {
      this.time = time;
    });
  }

  ngOnDestroy() {
    this.reset();
  }

}
